import { ColumnFieldType } from '../../enums/index';
import { ColumnFieldTypeObject } from '../ColumnFieldTypeObject';

export class ColumnStringDto extends ColumnFieldTypeObject {
  // todo: the type of dataDto should be updated to be generic
  FormatCallback: (dataDto: object) => string;

  constructor(init?: Partial<ColumnStringDto>) {
    super();
    this.FieldType = ColumnFieldType.String;
    Object.assign(this, init);
  }
}
